export enum TREATMENTS {
  preApprovalVersion = 'preApprovalVersion',
  ecommerceMonitoring = 'allyPortalEcommerceMonitoring',
}
